import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { InventoryService } from '../inventory.service';
import { GlobalResponse } from '@app/shared-module/models';
import { Constants } from '@app/shared-module/constants';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-edit-threshhold',
  templateUrl: './edit-threshhold.component.html',
  styleUrls: ['./edit-threshhold.component.scss']
})
export class EditThreshholdComponent implements OnInit {
  public threshold: number;
  public headerTitle: string;
  public drugId: string;
  @BlockUI() blockUI: NgBlockUI;
  constructor(
    public dialogRef: MatDialogRef<EditThreshholdComponent>,
    private service: InventoryService
  ) { }

  ngOnInit() {
  }
  updateThresholdItem() {
    this.blockUI.start();
    this.service.updateThreshold(this.threshold, this.drugId).subscribe((res: GlobalResponse) => {
      this.blockUI.stop();
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        // console.log(res.result);
        this.dialogRef.close(res.result);
      }
    });
  }
}
